let uniqueId = 0

export function saleVsItem(id) {
      uniqueId++

      return `
      <div class="line line-${id}" lineId="${id}">
        <div class="row pl-28">
          <div class="c50 itemname">
            <div class="row">
              <div class="c100">
                <div class="textfield textfield-autocomplete textfield-autocomplete-mini textfield-autocomplete-disabled purchase_vs_itemId"
                  id="retailDeleted_form_item_mt_${uniqueId}" selected="[]" max="1">
                  <input autocomplete="off" class="elem" type="text" readonly>
                  <div class="chip-cont"></div>
                  <div class="dn otherField"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="c50 itemdetail" style="margin: 0px">
            <div class="row">
              <div class="c25">
                <div class="textfield textfield-disabled textfield-mini selling_type">
                  <input autocomplete="off" class="elem" type="text" readonly>
                </div>
              </div>
              <div class="c25">
                <div class="textfield textfield-mini qty">
                  <input autocomplete="off" class="elem" type="number" readonly>
                </div>
              </div>
              <div class="c25">
                <div class="textfield textfield-mini textfield-cash price">
                  <input autocomplete="off" class="elem" type="number" readonly>
                </div>
              </div>
              <div class="c25">
                <div class="textfield textfield-mini textfield-cash total">
                  <input autocomplete="off" class="elem" type="number" readonly>
                </div>
              </div>
            </div>
          </div>

          <div class="dn cost"><input class="elem" type="text" readonly></div>
          <div class="dn cogs_row_amount"><input class="elem" type="text" readonly></div>
        </div>
      </div>`
}
